import { render, staticRenderFns } from "./SpeakApplyMenu.vue?vue&type=template&id=4da47d21&scoped=true"
import script from "./SpeakApplyMenu.vue?vue&type=script&lang=js"
export * from "./SpeakApplyMenu.vue?vue&type=script&lang=js"
import style0 from "./SpeakApplyMenu.vue?vue&type=style&index=0&id=4da47d21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da47d21",
  null
  
)

export default component.exports